import WindowedSelect, { Props } from 'react-windowed-select';
import style from './Select.module.css';

const defaultClassName = style.windowedSelect;

const Component = (<T,>(props: Props<T>) => {
  return <WindowedSelect {...props} className={props.className ?? defaultClassName} />;
}) as unknown as typeof WindowedSelect;

export const Select = Object.assign(Component, {
  className: defaultClassName,
});
